module.exports = __webpack_public_path__ + "img/Logo-07.82cb684b.png";